// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"881cb5fc","533":"4d31a616","681":"93de0a22","885":"4962098d"}[chunkId] + ".chunk.css";
};